import type { QueryKey, UseQueryOptions } from '@tanstack/react-query';
import { getWishlistProducts, type WishlistProductsParams } from './wishlist.api';
import type { OptionalQueryOptions, QueryApiOptions } from '../../types/types';
import { WishlistProduct } from '@as-react/common-types';

export const wishlistQueryKeys = {
  all: () => ['wishlist'] as QueryKey,
  wishlistProducts: (params: WishlistProductsParams) =>
    [...wishlistQueryKeys.all(), 'WishlistGetProducts', params] as QueryKey,
};

export const wishlistQueries = (apiOptions: QueryApiOptions) => ({
  getWishlistProducts: <TReturnData>(
    params: WishlistProductsParams,
    options: OptionalQueryOptions<Array<WishlistProduct>, TReturnData> = {}
  ) =>
    ({
      ...options,
      queryKey: wishlistQueryKeys.wishlistProducts(params),
      queryFn: () => getWishlistProducts(apiOptions, params),
    }) as UseQueryOptions<Array<WishlistProduct>, Error, TReturnData>,
});
